import { axiosInstance } from "../../../../Services";

export const fetchBoardLists = async (boardId) => {
  try {
    const res = await axiosInstance.get(`/mmhboard/boards/list/${boardId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const fetchListCards = async (listId) => {
  try {
    const res = await axiosInstance.get(`/mmhboard/lists/card/${listId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const linkRelatedCard = async (cardId, relatedCardId) => {
  try {
    const formData = new FormData();
    formData.append('related_card_id', relatedCardId);

    const res = await axiosInstance.post(
      `/mmhboard/cards/relate/${cardId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const getCardDetails = async (cardId) => {
    try {
      const res = await axiosInstance.get(`/mmhboard/cards/${cardId}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
